import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import translationsEN from './en/en.json';
import legalEN from './en/en.legal.json';
import translationsHU from './hu/hu.json';
import translationsRO from './ro/ro.json';

const resources = {
  en: {
    translation: translationsEN,
    legal: legalEN
  },
  hu: {
    translation: translationsHU
  },
  ro: {
    translation: translationsRO
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'en', // default language
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });
  
  export default i18n;